module.exports = __webpack_public_path__ + "img/user.4c72f598.svg";